/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response for MNCAP medical validation token check.
 * @export
 * @interface MncapValidateTokenResponseDto
 */
export interface MncapValidateTokenResponseDto {
    /**
     * State of the validation token.
     * - PENDING_VALIDATION: AERAS reading + SMS code still required
     * - ALREADY_VALIDATED: borrower already went through validation, redirect immediately
     * - EXPIRED: token lifetime reached
     * - INVALID: token does not exist or was revoked
     * 
     * @type {string}
     * @memberof MncapValidateTokenResponseDto
     */
    status: MncapValidateTokenResponseDtoStatusEnum;
    /**
     * Pre-signed, short-lived URL (recommended TTL 10 min) pointing to the AERAS PDF
     * stored in blob storage. The front embeds it directly in an iframe, no auth needed.
     * Only filled when status is PENDING_VALIDATION.
     * 
     * @type {string}
     * @memberof MncapValidateTokenResponseDto
     */
    aerasFileUrl?: string | null;
    /**
     * MIME type of the AERAS document (typically application/pdf).
     * @type {string}
     * @memberof MncapValidateTokenResponseDto
     */
    aerasFileMimeType?: string | null;
    /**
     * Masked phone number where the SMS will be sent (e.g. "06 ** ** ** 42").
     * Only filled when status is PENDING_VALIDATION.
     * 
     * @type {string}
     * @memberof MncapValidateTokenResponseDto
     */
    phoneMasked?: string | null;
    /**
     * MNCAP health questionnaire URL.
     * Only filled when status is ALREADY_VALIDATED (front redirects immediately).
     * 
     * @type {string}
     * @memberof MncapValidateTokenResponseDto
     */
    redirectUrl?: string | null;
}


/**
 * @export
 */
export const MncapValidateTokenResponseDtoStatusEnum = {
    PendingValidation: 'PENDING_VALIDATION',
    AlreadyValidated: 'ALREADY_VALIDATED',
    Expired: 'EXPIRED',
    Invalid: 'INVALID'
} as const;
export type MncapValidateTokenResponseDtoStatusEnum = typeof MncapValidateTokenResponseDtoStatusEnum[keyof typeof MncapValidateTokenResponseDtoStatusEnum];


/**
 * Check if a given object implements the MncapValidateTokenResponseDto interface.
 */
export function instanceOfMncapValidateTokenResponseDto(value: object): value is MncapValidateTokenResponseDto {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function MncapValidateTokenResponseDtoFromJSON(json: any): MncapValidateTokenResponseDto {
    return MncapValidateTokenResponseDtoFromJSONTyped(json, false);
}

export function MncapValidateTokenResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MncapValidateTokenResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'aerasFileUrl': json['aerasFileUrl'] == null ? undefined : json['aerasFileUrl'],
        'aerasFileMimeType': json['aerasFileMimeType'] == null ? undefined : json['aerasFileMimeType'],
        'phoneMasked': json['phoneMasked'] == null ? undefined : json['phoneMasked'],
        'redirectUrl': json['redirectUrl'] == null ? undefined : json['redirectUrl'],
    };
}

export function MncapValidateTokenResponseDtoToJSON(json: any): MncapValidateTokenResponseDto {
    return MncapValidateTokenResponseDtoToJSONTyped(json, false);
}

export function MncapValidateTokenResponseDtoToJSONTyped(value?: MncapValidateTokenResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'aerasFileUrl': value['aerasFileUrl'],
        'aerasFileMimeType': value['aerasFileMimeType'],
        'phoneMasked': value['phoneMasked'],
        'redirectUrl': value['redirectUrl'],
    };
}

